import { AppError } from '../error';

export const getDefaultError = (path: string): AppError => {
  return new AppError({
    error: 'Unknown',
    message: 'Something went wrong',
    status: 500,
    path,
    timestamp: new Date().toISOString(),
  });
};

export const getParseError = (path: string): AppError => {
  return new AppError({
    error: 'Parse Error',
    message: 'Failed to parse response JSON',
    status: 500,
    path,
    timestamp: new Date().toISOString(),
  });
};

export const getDataValidationError = (path: string): AppError => {
  return new AppError({
    error: 'Data Validation Error',
    message: 'Failed to validate response data',
    status: 500,
    path,
    timestamp: new Date().toISOString(),
  });
};
